import server from './http'

const checkResponse = (request) => request.then(res => {
    if (res && Number(res.code) === 500) {
        throw new Error(res.msg || '请求失败')
    }
    return res
})

const employmentApi = {
    createContractOrder: (param) => checkResponse(server.post('/manage/createContractOrder', param)), // 创建合同订单
    getContractOrderList: (param) => checkResponse(server.post('/manage/contractOrderList', param)), // 合同列表
    getContractDetail: (param) => checkResponse(server.post('/manage/contractDetail', param)), // 合同详情
}

export default employmentApi
